module.exports = __webpack_public_path__ + "img/laurel.8e9351fe.svg";